// extracted by mini-css-extract-plugin
module.exports = {"metrics_pm":"MemorandumValues_metrics_pm__3JgWU","column_metrics":"MemorandumValues_column_metrics__2Y-oR"};